import React from 'react';
import Aux from '../../../../hoc/_Aux';

const DoubleHalfCircle = (props) => {

    let shape1Style = {};
    let shape2Style = {};
    let globalSVGStyle = {};
    if(typeof props.color1 !=='undefined'){
        shape1Style = {'fill':props.color1}
    }
    if(typeof props.color2 !=='undefined'){
        shape2Style = {'fill':props.color2}
    }
    
    if(typeof props.rotateAngle!== 'undefined'){
        globalSVGStyle = {transform: 'rotate('+props.rotateAngle+'deg)'};
    }

    return(
        <Aux>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 158 144" style={globalSVGStyle}>
            <g transform="matrix(0.996, 0.087, -0.087, 0.996, 32.972, -243.642)">
                <g transform="translate(14.544 243.3)">
                    <path style={shape1Style} d="M7.5,351.892l10.471-10.277a62.664,62.664,0,0,0,89.2-88.037L117.643,243.3c30.057,30.251,29.669,79.311-.582,109.368C86.617,382.336,37.557,382.143,7.5,351.892Z" transform="translate(-7.5 -243.3)"/>
                </g>
                <g transform="translate(0 246.79)">
                   <path style={shape2Style} d="M0,353.692l10.471-10.277a62.664,62.664,0,0,0,89.2-88.037L110.143,245.1c30.057,30.251,29.669,79.311-.582,109.368A77.835,77.835,0,0,1,0,353.692Z" transform="translate(0 -245.1)"/>
                </g>
            </g>
            </svg>
        </Aux>
    );
}

export default DoubleHalfCircle;


// WEBPACK FOOTER //
// ./src/containers/UI/Common/Shapes/DoubleHalfCircle.js